<script setup lang="ts">
import { useField } from 'vee-validate';
import { toRef } from 'vue';

import InputLabel from '@/components/forms/helpers/InputLabel.vue';
import InputError from '@/components/forms/helpers/InputError.vue';
import OptionLabel from '@/components/forms/helpers/OptionLabel.vue';
import Checkbox from 'primevue/checkbox';

interface CheckboxOption {
  value: string;
  label: string;
  attributes?: Record<string, any>;
}

interface Props {
  label?: string;
  options?: CheckboxOption[];
  name?: string;
  tooltip?: string;
  tooltipIcon?: string;
  required?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  label: undefined,
  options: () => [{ value: 'option-1', label: 'Option 1', attributes: {} }],
  name: 'checkbox',
  tooltip: undefined,
  tooltipIcon: 'pi-info-circle',
  required: false,
});

const { errorMessage, value } = useField<string[]>(toRef(props, 'name'));
</script>

<template>
  <div>
    <InputLabel
      :name="name"
      :label="label"
      :tooltip="tooltip"
      :tooltip-icon="tooltipIcon"
      :required="required"
      v-if="label"
    >
      <slot name="label"></slot>
    </InputLabel>
    <div
      class="flex py-3"
      v-for="(option, index) in options"
      :key="`${name}-${index}`"
    >
      <Checkbox
        :name="`${name}`"
        :value="option.value"
        v-model="value"
        :inputId="`${name}-${index}`"
        :class="{ 'p-invalid': errorMessage }"
        v-bind="option.attributes"
      />
      <OptionLabel :name="name" :index="index" :label="option.label" />
    </div>
    <InputError :name="name" :error-message="errorMessage" />
  </div>
</template>
